// extracted by mini-css-extract-plugin
export default {"btn":"index_btn__rLgcv","text":"index_text__-Om-8","error":"index_error__nt5kL"};